import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/maintenance.js";

export function useMaintenanceWindows(options = {}) {
  return useQuery({
    queryKey: keys.maintenance.list,
    queryFn: api.fetchMaintenanceWindows,
    ...options,
  });
}

export function useMaintenanceWindow(id, options = {}) {
  return useQuery({
    queryKey: ["maintenance", "detail", id],
    queryFn: () => api.fetchMaintenanceWindow(id),
    enabled: !!id,
    ...options,
  });
}

export function useCreateMaintenanceWindow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createMaintenanceWindow,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.maintenance.all }),
  });
}

export function useUpdateMaintenanceWindow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateMaintenanceWindow(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.maintenance.all }),
  });
}

export function useDeleteMaintenanceWindow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteMaintenanceWindow,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.maintenance.all }),
  });
}
